<template>
    <div class="flex_row_center">
      <div class="main" style="margin-top:50px;width:80%;">
        <div class="swiper1" @mouseover="mySwiperStop" @mouseout="mySwiperStart">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in pic" :key="index">
            <div class="flex_column_center">
              <viewer>
              <img :src="item.url" alt="" class="swiper-slide-img" />
             </viewer>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </template>
  
  <script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
  var global = require("@/utils/global");
  
  export default {
    name: "partners",
    components: {
    },
    data() {
      return {
        mySwiper1: undefined,
        pic: [
          {
            url: global.pictureBaseUrl + "/parterners/1.jpg",
          },
          {
            url: global.pictureBaseUrl + "/parterners/2.jpg",
          },
          {
            url: global.pictureBaseUrl + "/parterners/3.png",
          },
          {
            url: global.pictureBaseUrl + "/parterners/4.png",
          },
          {
            url: global.pictureBaseUrl + "/parterners/公牛集团.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/杭州城投.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/绿城集团.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/宁波动力.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/宁波雅戈尔置业.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/荣安地产.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/万达集团.jpg",
          },
          {
           url: global.pictureBaseUrl + "/parterners/维科置业.jpg",
          },
        ],
      };
    },
    mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  methods: {
    initSwiper() {
      this.mySwiper1 = new Swiper(".swiper1", {
        initialSlide: 5,
        spaceBetween: 30,
        slidesPerView: 3, // 一屏显示的slide个数
        observer: true,
        observerParents: true,
        autoplay: {
          delay: 500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 2000,
        loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
      });
    },
    mySwiperStart() {
      if (this.mySwiper1) {
        this.mySwiper1.autoplay.start();
      }
    },
    mySwiperStop() {
      if (this.mySwiper1) {
        this.mySwiper1.autoplay.stop();
      }
    },
  },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
.swiper1 {
  overflow: hidden;
}
  ::v-deep .swiper-wrapper {
    -webkit-transition-timing-function: linear;
      -moz-transition-timing-function: linear;
      -ms-transition-timing-function: linear;
      -o-transition-timing-function: linear;
      transition-timing-function: linear;
  }
  .swiper-slide-img {
    width: 280px;
  }
  @media screen and (max-width: 780px) {
  .swiper-slide-img {
  width: 80px;
}
}
  </style>
  


// WEBPACK FOOTER //
// src/components/public/partners.vue